import { FC, useContext } from 'react';
// 组件
import SuperForm from '../../../../SuperForm';
// 方法
import StrategyCountext from '../../../context/strategyCountext';
import { StrategyPageRightProps } from '../../../interface';

const Right: FC<StrategyPageRightProps> = props => {
  const { actionFormRef, disabled } = props;
  const { actionFormItems } = useContext(StrategyCountext);
  return (
    <div className="yb-StrategyPage-right yb-StrategyPage-item">
      <SuperForm
        actionRef={actionFormRef}
        testId='strategy-page-content-1'
        formItems={actionFormItems}
        defaultLineNumber={1}
        defaultLabelCol={{span: 8}}
        disabled={disabled}
      />
    </div>
  );
};

export default Right;
